/**
 * Adzuki.TitleAlert
 * flashing tab/window titles
 */

(function TitleAlert($, Adzuki)
{
	"use strict";

	var _interval = null,
	    _title    = null;

	var title = function TitleAlert(text)
	{
		if (title.running) {
			title.stop();
		}

		title.running = true;
		_title        = document.title;
		_interval     = setInterval(function swapTitle() {
			document.title = (document.title === _title) ? text : _title;
		}, 1000);

		$(window).on('focus', Adzuki.TitleAlert._focus);
	};

	title.running = false;

	title._focus = function focus() {
		if (title.running) {
			title.stop();
		}
	};

	title.stop = function stop() {
		clearInterval(_interval);
		document.title = _title;
		title.running  = false;
		$(window).off('focus');
	};


	Adzuki.TitleAlert = title;
}(jQuery, window.Adzuki || {}));